// The profit board is a winners' list, not a roll call. The server ranks
// everyone with enough bets in the window, losers included, so the tail of the
// list used to be a column of red minus signs — a player's losses next to
// their avatar and VIP badge, for everyone to see (2026-09-04 review). Only
// players who are up in the window are shown; your own standing still reaches
// you privately through the "you" bar, which reads the server's `me` row.
import type { LeaderboardPeriod } from '../../features/leaderboard/api';

export function inProfitOnly<T extends { profit: number }>(rows: T[]): T[] {
  return rows.filter((row) => Number(row.profit) > 0);
}

// The short windows (30 minutes, an hour) can honestly have nobody in profit.
// The empty state then offers the next window up rather than a dead end.
const PROFIT_PERIODS: LeaderboardPeriod[] = ['30m', '1h', '3h', 'today'];

export function longerPeriod(current: LeaderboardPeriod): LeaderboardPeriod | null {
  const i = PROFIT_PERIODS.indexOf(current);
  if (i === -1) return null;
  return PROFIT_PERIODS[i + 1] ?? null;
}
